import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { AlertTriangle } from 'lucide-react';

// GO-LIVE #1: visible on every screen (not just the send dialog) while
// email or SMS test mode is active — the biggest go-live risk is a silent
// redirect that nobody notices until a real customer says "never got it".
export function TestModeBanner() {
  const [emailStatus, setEmailStatus] = useState(null);
  const [smsStatus, setSmsStatus] = useState(null);

  useEffect(() => {
    Promise.all([
      api.get('/emails/status').catch(() => null),
      api.get('/voice/sms/status').catch(() => null),
    ]).then(([em, sm]) => {
      setEmailStatus(em?.data || null);
      setSmsStatus(sm?.data || null);
    });
  }, []);

  const emailTest = !!(emailStatus?.configured && emailStatus?.test_mode);
  const smsTest = !!(smsStatus?.configured && smsStatus?.test_mode);
  if (!emailTest && !smsTest) return null;

  const parts = [];
  if (emailTest) parts.push(`Emails → ${emailStatus?.test_to || 'test inbox'}`);
  if (smsTest) parts.push('SMS → test number');

  return (
    <div
      data-testid="test-mode-banner"
      className="sticky top-0 z-[70] w-full bg-amber-500 text-[#1a1400] px-4 py-2 flex items-center justify-center gap-2 text-xs sm:text-sm font-semibold shadow-md"
    >
      <AlertTriangle className="w-4 h-4 flex-shrink-0" />
      <span>
        TEST MODE — messages are NOT reaching customers ({parts.join(' · ')}). Turn it off in
        Settings → Maintenance before going live.
      </span>
    </div>
  );
}

export default TestModeBanner;
